export const sanitizeMarkdown = (markdown: string) => {
  // at-encode at character
  let sanitizedMd = markdown.replaceAll('@', '@at;');

  // now all other escapable chars
  sanitizedMd = sanitizedMd.replaceAll('\\\\', '@bsh;')
  .replaceAll('\\#', '@hsh;')
  .replaceAll('\\-', '@dsh;')
  .replaceAll('\\`', '@acg;')
  .replaceAll('\\~', '@tde;')
  .replaceAll('\\*', '@ask;')
  .replaceAll('\\_', '@usc;')
  .replaceAll('\\|', '@pipe;')
  .replaceAll('\\:', '@col;')
  .replaceAll('\\$', '@usd;') // relevant only for time app
  .replaceAll('\\=', '@eq;')
  .replaceAll('\\^', '@crt;')
  .replaceAll('\\(', '@lpr;')
  .replaceAll('\\)', '@rpr;')
  .replaceAll('\\!', '@exc;')
  .replaceAll('\\[', '@lsq;')
  .replaceAll('\\]', '@rsq;')
  .replaceAll('\\>', '@gt;')
  .replaceAll('\\+', '@pls;')
  .replaceAll('\\.', '@dot;')
  .replaceAll('%', '@per;') // used to simplify pattern matching for some decorators
  .replaceAll('&', '@amp;')
  .replaceAll('<', '&lt;');

  return sanitizedMd;
}

export const desanitizeMarkdown = (markdown: string) => {
  // at-encode at character
  let desanitizedMd = markdown.replaceAll('@at;', '@')
  .replaceAll('@bsh;', '\\')
  .replaceAll('@hsh;', '#')
  .replaceAll('@dsh;', '-')
  .replaceAll('@acg;', '`')
  .replaceAll('@tde;', '~')
  .replaceAll('@ask;', '*')
  .replaceAll('@usc;', '_')
  .replaceAll('@pipe;', '|')
  .replaceAll('@col;', ':')
  .replaceAll('@usd;', '$')
  .replaceAll('@eq;', '=')
  .replaceAll('@crt;', '^')
  .replaceAll('@lpr;', '(')
  .replaceAll('@rpr;', ')')
  .replaceAll('@exc;', '!')
  .replaceAll('@lsq;', '[')
  .replaceAll('@rsq;', ']')
  .replaceAll('@gt;', '>')
  .replaceAll('@pls;', '+')
  .replaceAll('@dot;', '.')
  .replaceAll('@per;', '%')
  .replaceAll('@amp;', '&');

  return desanitizedMd;
}

export const sanitizeSymbols = (markdown: string) => {
  const sanitizedMd = markdown.replaceAll('\\', '@bsh;')
  .replaceAll('#', '@hsh;')
  .replaceAll('-', '@dsh;')
  .replaceAll('`', '@acg;')
  .replaceAll('~', '@tde;')
  .replaceAll('*', '@ask;')
  .replaceAll('_', '@usc;')
  .replaceAll('|', '@pipe;')
  .replaceAll(':', '@col;')
  .replaceAll('$', '@usd;') // relevant only for time app
  .replaceAll('=', '@eq;')
  .replaceAll('^', '@crt;')
  .replaceAll('(', '@lpr;')
  .replaceAll(')', '@rpr;')
  .replaceAll('!', '@exc;')
  .replaceAll('[', '@lsq;')
  .replaceAll(']', '@rsq;')
  .replaceAll('>', '@gt;')
  .replaceAll('+', '@pls;')
  .replaceAll('.', '@dot;')
  .replaceAll('@amp;', '&amp;')
  .replaceAll(/<\/?code(?:@gt;|>)/g, '`');

  return sanitizedMd;
}